import { ReactWidget } from '@theia/core/lib/browser';
import { injectable, postConstruct } from '@theia/core/shared/inversify';

type UiModule = {
    UpdateAvailable: () => JSX.Element;
};

@injectable()
export class UpdateAvailableHostWidget extends ReactWidget {
    static readonly ID: string = 'widget:lved-update-available-host';

    protected module: UiModule | undefined;

    @postConstruct()
    protected init(): void {
        this.doInit();
    }

    protected async doInit(): Promise<void> {
        this.id = UpdateAvailableHostWidget.ID;
        this.title.closable = false;
        this.node.id = 'lved-update-available-host';
        await this.loadModule();
        this.update();
    }

    protected async loadModule(): Promise<void> {
        try {
            this.module = (await import('@lved/ui')) as unknown as UiModule;
        } catch {
            this.module = undefined;
        }
    }

    protected override render(): JSX.Element {
        if (!this.module) return <></>;
        const UpdateAvailable = this.module.UpdateAvailable;
        return <UpdateAvailable />;
    }
}
